import type { Release } from '../releases';

export default {
  id: '2026-11-01-site-offline-acceptance',
  at: '2026-11-01T18:10:00Z',
  title: 'Площадка без связи: приёмка поставки уходит один раз',
  modules: ['site'],
  items: [
    'Приёмка поставки, набранная на телефоне без связи, уходит на портал ровно один раз: если связь оборвалась на середине отправки, повтор не создаёт вторую приёмку и не грузит фото накладной заново.',
    'Если на телефоне вошёл другой человек, чужие неотправленные приёмки не уходят от его имени — они ждут прежнего владельца.',
    'Приёмка, которую портал не принял (например, поставка уже закрыта), видна в «Моём дне» с причиной и кнопкой «Отправить снова».',
  ],
  why: 'При плохой связи на объекте приёмка могла «повиснуть» с ошибкой после потерянного ответа, а фото загружались по нескольку раз.',
  link: '/site/day',
} satisfies Release;
